import dayjs, { Dayjs } from "dayjs";

export const dayjsToDateString = (date: Dayjs): string => {
  return date.format("YYYY-MM-DD");
};

export const dayjsToDateTimeString = (date: Dayjs): string => {
  return date.format("YYYY-MM-DD HH:mm");
};

export const formatTimeWithOptionalMinutes = (timeString: string) => {
  const today = dayjs();
  const timeStringDayJsFormat = today.format("YYYY-MM") + "T" + timeString;
  const time = dayjs(timeStringDayJsFormat);
  const minutes = time.minute();

  // If minutes are zero, only show hours
  if (minutes === 0) {
    return time.format("HH");
  }

  // Otherwise show hours and minutes
  return time.format("HH:mm");
};
